import { WatchLaterOutlined } from '@mui/icons-material'
import { Button, InputAdornment, Popover, TextField } from '@mui/material'
import { useEffect, useState } from 'react'
import {
  autoFormatTime,
  checkIsSelected,
  formatTimeToHMS,
  hmsToSeconds,
  secondsToHMS,
} from '../../../Helpers/DurationHelper'

const DurationPicker = ({
  name,
  label,
  value,
  onChangeValue,
  error,
  required = false,
  maxHourDigits = 3,
}: any) => {
  const zeroValue = `${String(0).padStart(maxHourDigits, '0')}:00:00`
  const [inputValue, setInputValue] = useState('')
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [isInputChange, setisInputChange] = useState(false)

  useEffect(() => {
    // eslint-disable-next-line eqeqeq
    if (value && value >= 0 && value != hmsToSeconds(inputValue)) {
      setInputValue(secondsToHMS(value, maxHourDigits))
    }
  }, [value, maxHourDigits])

  useEffect(() => {
    if (!(inputValue === '' && (value === null || value === undefined))) {
      if (inputValue) {
        onChangeValue(Number(hmsToSeconds(inputValue)))
      } else if (value === 0 && !isInputChange) {
        setInputValue(zeroValue)
        onChangeValue(Number(hmsToSeconds(zeroValue)))
      } else {
        onChangeValue(null)
      }
    }
  }, [inputValue])

  const handleChange = (event: any) => {
    const value = event.target.value

    // Allow only numbers and colons, and ensure format is HH:MM:SS with hours up to 999
    const regex = new RegExp(`^(\\d{0,${maxHourDigits}}):?(\\d{0,2})?:?(\\d{0,2})?$`) // NOSONAR
    if (regex.test(value)) {
      setisInputChange(true)
      const formattedValue = autoFormatTime(value, maxHourDigits)
      setInputValue(formattedValue)
    }
  }

  const handleClickTime = (type: string, value: string) => {
    let [part0 = 0, part1 = 0, part2 = 0] = inputValue.split(':')
    if (type === 'h') {
      part0 = value
    } else if (type === 'm') {
      part1 = value
    } else if (type === 's') {
      part2 = value
    }
    setInputValue(formatTimeToHMS(`${part0}:${part1}:${part2}`, maxHourDigits))
  }

  const getTimeList = (type: string) => {
    return Array.from({ length: type === 'h' ? 10 ** maxHourDigits : 60 }, (_, i) => i).map((i) => (
      <li
        key={i}
        className={
          checkIsSelected(String(i), inputValue, type as any, maxHourDigits)
            ? `li-${type} selected`
            : `li-${type}`
        }
        onClick={() => handleClickTime(type, String(i))}
      >
        {String(i).padStart(type === 'h' ? maxHourDigits : 2, '0')}
      </li>
    ))
  }

  const handleClickOk = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <TextField
        fullWidth
        autoComplete='none'
        label={
          <span>
            {label}
            {required && <span style={{ color: '#D4351C' }}>*</span>}
          </span>
        }
        name={name}
        placeholder='HH:MM:SS'
        value={inputValue}
        onChange={handleChange}
        InputProps={{
          endAdornment: (
            <InputAdornment
              position='end'
              onClick={(event: any) => {
                setAnchorEl(event.currentTarget.previousElementSibling)
              }}
              sx={{ cursor: 'pointer' }}
            >
              <WatchLaterOutlined />
            </InputAdornment>
          ),
        }}
        onBlur={() => {
          if (inputValue) {
            setInputValue(formatTimeToHMS(inputValue, maxHourDigits))
          }
        }}
        error={!!error?.[name]}
        helperText={error?.[name]?.message as string}
      />
      <Popover
        className='duration-dropdown'
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null)
        }}
      >
        <div className='duration-layout-root'>
          <div className='duration-wrapper'>
            <div className='duration-time'>
              <ul className='ul-h'> {getTimeList('h')} </ul>
              <ul className='ul-m'> {getTimeList('m')} </ul>
              <ul className='ul-s'> {getTimeList('s')} </ul>
            </div>
          </div>
        </div>
        <div className='duration-action'>
          <Button color='primary' onClick={handleClickOk}>
            OK
          </Button>
        </div>
      </Popover>
    </>
  )
}

export default DurationPicker
